<template>
  <v-navigation-drawer
    class="navi-drawer"
    fixed
    :clipped="$vuetify.breakpoint.mdAndUp"
    :class="$vuetify.breakpoint.mdAndUp ? 'grey lighten-3' : ''"
    app
    :value="isDrawerOpen"
    disable-route-watcher
    mobile-break-point="960"
    @input="
      (open) => {
        toggleDrawer(open);
      }
    "
  >
    <div v-if="$vuetify.breakpoint.smAndDown" :style="{ position: 'relative' }">
      <img src="/assets/material-background.png" width="300">
      <v-avatar class="primary" :style="{ position: 'absolute', left: '17px', top: '10%' }">
        <span class="white--text headline">{{ userInitials }}</span>
      </v-avatar>
      <div
        :style="{
          position: 'absolute',
          left: '17px',
          bottom: '10%',
          color: 'white',
        }"
      >
        <div>{{ currentlyLoggedUser }}</div>
        <div>{{ currentlyLoggedUserCityAndBalance }}</div>
      </div>
    </div>

    <drawer-days :days="days" :loading="loadingDays > 0 || isDrawerLoading" />
    <v-divider />
    <drawer-list :items="optionsItems" />
    <v-divider />
    <drawer-list :items="bottomItems" />
  </v-navigation-drawer>
</template>

<script>
import gql from 'graphql-tag';
import { mapGetters, mapActions } from 'vuex';
import ErrorHandler from '@/services/ErrorHandler';
import { apolloClient } from '@/apollo';
import DrawerList from './drawer-list/DrawerList.vue';
import DrawerDays from './drawer-list/DrawerDays.vue';

export default {
  name: 'AppDrawer',
  components: {
    'drawer-list': DrawerList,
    'drawer-days': DrawerDays,
  },
  data() {
    return {
      days: [],
      userName: 'a',
      loadingDays: 0,
    };
  },
  computed: {
    ...mapGetters('drawerStore', ['isDrawerOpen', 'currentRoute', 'optionsItems', 'bottomItems', 'isDrawerLoading']),
    ...mapGetters('dishesStore', ['activeSelectionsState']),
    ...mapGetters('userInfoStore', ['userData', 'cities']),
    currentlyLoggedUser() {
      return this.userData.displayName;
    },
    userInitials() {
      const user = this.currentlyLoggedUser;

      if (user) {
        return user
          .split(' ')
          .map(t => t[0])
          .join('')
          .toUpperCase();
      }

      return '';
    },
    currentlyLoggedUserCityAndBalance() {
      return this.userData.cityId
        ? `${this.cities.find(x => x.id === this.userData.cityId).name}, ${this.$t('usersBalancesContainer.balance')}: ${this.userData.balance.toFixed(2)} €`
        : '';
    },
  },
  watch: {
    currentRoute(newRoute) {
      this.$router.push(newRoute.path);
    },
    activeSelectionsState(newState) {
      if (newState === 'done') {
        apolloClient.queryManager.refetchQueryByName('DaysQuery');
      }
    },
  },
  created() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.toggleDrawer(false);
    }
  },
  beforeMount() {
    this.navigate({
      path: this.$route.path,
      day: this.$route.params.day,
    });
  },
  methods: {
    ...mapActions('drawerStore', ['toggleDrawer', 'navigate', 'updateProviders']),
  },
  apollo: {
    $loadingKey: 'loadingDays',
    days: {
      fetchPolicy: 'network-only',
      query: gql`
        query DaysQuery {
          days {
            userHasOrder
            dayOfWeek
            orderUntil
            providers {
              color
              name
            }
          }
        }
      `,
      skip() {
        return !this.userData.cityId;
      },
      error(error) {
        this.day = null;

        if (!this.loadingDishes) {
          ErrorHandler.handleApolloError(error);
        }
      },
      result(r) {
        const day = r.data.days.filter(d => d.providers.length > 0).find(d => d.dayOfWeek === this.$route.params.day);
        if (!day) {
          this.updateProviders([]);
          if (this.currentRoute.isDishesOverview) {
            const firstDay = r.data.days[0];
            if (firstDay) {
              this.navigate({
                path: `/dishes/${firstDay.dayOfWeek}`,
                day: firstDay.dayOfWeek,
              });
            }
          }
        } else {
          this.updateProviders(
            day.providers.map(p => ({
              path: `/dishes/${day.dayOfWeek}/${p.name}`,
              day: day.dayOfWeek,
              provider: p.name,
            })),
          );
        }
      },
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer .v-list {
  background: inherit !important;
}
.navi-drawer {
  padding-bottom: 0 !important;
}
.navi-drawer .text {
  font-weight: 400;
}
.navi-drawer .divider {
  background-color: rgba(0, 0, 0, 0.07);
}
/* Used for drawer border hiding */
.navi-drawer >>> .v-navigation-drawer__border {
  display: none !important;
}
/* Used for drawer days list items border removing */
.list >>> .list__group--active:before,
.drawer-days >>> .list__group--active:after {
  content: none;
}
</style>
